module.exports = __webpack_public_path__ + "img/20.d5e298f4.jpg";